// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }

  // Boost Start #169552
  InstantSearchResultItemProduct.prototype.setData = function(data) {
		if (data) {
			this.data = data;
			this.id = data.id;
			this.title = Utils.stripHtml(data.title);
			this.imageUrl = data.images_info.length > 0 ? Utils.optimizeImage(data.images_info[0].src, '800x') : boostPFSConfig.general.no_image_url;
			this.url = Utils.buildProductItemUrlWithVariant(data);
			this.sku = Utils.stripHtml(data.skus && data.skus.length > 0 ? data.skus[0] : '');
			this.label = Utils.stripHtml(data.label);
			this.vendor = Utils.stripHtml(data.vendor);
			this.isShow = true;
		} else {
			this.data = null;
			this.id = '';
			this.title = '';
			this.imageUrl = '';
			this.url = '';
			this.sku = '';
			this.label = '';
			this.vendor = '';
			
			this.isShow = false;
		}
	}
    // End #169552
  
})();